module.exports = __webpack_public_path__ + "static/img/l-banner.eb697fd0.webp";